<template>
  <section class="social-networks">
    <div class="social-networks__title">
      <span> Войти с помощью </span>
    </div>
    <ul>
      <li>
        <a href="https://auth.toolbox.bz/connect/google?platform=lms">
          <GoogleAuthIcon />
        </a>
      </li>
      <li>
        <a href="https://auth.toolbox.bz/connect/vkontakte?platform=lms">
          <VkAuthIcon />
        </a>
      </li>
      <li>
        <a href="https://auth.toolbox.bz/connect/yandex?platform=lms">
          <YandexAuthIcon />
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import GoogleAuthIcon from '@/components/Icons/GoogleAuthIcon';
import FacebookAuthIcon from '@/components/Icons/FacebookAuthIcon';
import VkAuthIcon from '@/components/Icons/VkAuthIcon';
import YandexAuthIcon from '@/components/Icons/YandexAuthIcon';

export default {
  name: 'SocialNetworksAuth',
  components: {
    GoogleAuthIcon,
    YandexAuthIcon,
    VkAuthIcon,
    FacebookAuthIcon
  }
};
</script>

<style scoped lang="scss">
@import 'src/style/utils';

.social-networks {
  &__title {
    @extend %text-400-14;
    color: #898989;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #eff1f8;
    line-height: 1px;
    margin: 36px 0 36px;

    span {
      background: #fff;
      padding: 0 10px;
    }
  }

  &--tight {
    .social-networks__title {
      margin: 26px 0 26px;
    }
  }

  ul {
    display: flex;
    flex-direction: row;
    justify-content: center;

    li {
      width: 50px;
      height: 50px;
      border-radius: 6px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
      transition: all 0.2s ease;

      &:hover {
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      }

      &:not(:first-child) {
        margin-left: 20px;
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
